import React from "react";

import styles from "./index.module.scss";

interface Props {
  maxCacheLength?: number;
  shouldCache?: boolean;
}

interface State {
  indexCache: number[];
}

class Tabs extends React.Component<Props, State> {
  public static defaultProps = {
    maxCacheLength: 5,
    shouldCache: false,
  };

  public state: State = {
    indexCache: [0],
  };

  public computeCache(prevCache: number[], newIndex: number) {
    const newCache = prevCache;
    newCache.push(newIndex);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (newCache.length > this.props.maxCacheLength!) {
      return newCache.slice(1);
    } else {
      return newCache;
    }
  }

  public pushToCache = (newIndex: number) => {
    this.setState((prevState) => ({
      indexCache: this.computeCache(prevState.indexCache, newIndex),
    }));
  };

  public render() {
    const { indexCache } = this.state;

    const augmentedChildren = React.Children.map(
      this.props.children,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (child: any) => {
        return React.cloneElement(child, {
          indexCache,
          onChange: this.pushToCache,
        });
      },
    );

    return <div className={styles.tabs}>{augmentedChildren}</div>;
  }
}

export { Tabs };
export { default as TabBookmark } from "./Bookmark";
export { default as TabBookmarkGroup } from "./BookmarkGroup";
export { default as TabContent } from "./Content";
export { default as TabContentGroup } from "./ContentGroup";
export { default as TabInfo } from "./Info";
export { default as TabInfoGroup } from "./InfoGroup";
export { default as TabInfoTitle } from "./InfoTitle";
